import { applyAction } from "./appliers";
import type { CubeHellAction, CubeHellState } from "./types";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: CubeHellState;
  readonly accepted: boolean;
  readonly error?: string;
}

// NOTE: does NOT validate — call validateAndReduceGameState at trust boundaries.
export function reduceGameState(
  state: CubeHellState,
  action: CubeHellAction,
): CubeHellState {
  return applyAction(state, action);
}

export function validateAndReduceGameState(
  state: CubeHellState,
  action: CubeHellAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, accepted: false, error: validation.error };
  }
  return { state: reduceGameState(state, action), accepted: true };
}
